<template>
  <div class="business-trip-container">
    <!-- Import PDF Component -->
    <BusinessTripReportPDF
      v-if="selectedReportId"
      ref="pdfComponent"
      :reportId="selectedReportId"
      :ApiKey="ApiKey"
    />

    <!-- Hero Header Section -->
    <v-card class="hero-header mb-6" elevation="0">
      <div class="hero-content">
        <div class="hero-icon-wrapper">
          <v-icon size="48" color="white">mdi-airplane-takeoff</v-icon>
        </div>
        <div class="hero-text">
          <h1 class="hero-title">รายงานการเดินทางไปราชการ</h1>
          <p class="hero-subtitle">
            บริหารจัดการรายงานการศึกษาดูงาน ประชุม และการเดินทางราชการ
          </p>
        </div>  
      </div>
    </v-card>

    <!-- Statistics Cards -->
    <v-row class="stats-row mb-6">
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-1" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-file-document</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ reports.length }}</span>
            <span class="stat-label">รายการทั้งหมด</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-2" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-clipboard-check</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countByStatus("approved") }}</span>
            <span class="stat-label">อนุมัติแล้ว</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-3" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-clock-outline</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countByStatus("pending") }}</span>
            <span class="stat-label">รอพิจารณา</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-4" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-calendar-range</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ totalDays }}</span>
            <span class="stat-label">วันรวม</span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Data Table Card -->
    <v-card class="main-table-card" elevation="0">
      <v-card-title class="table-header">
        <div class="header-left">
          <v-icon class="mr-3" color="#2563eb">mdi-format-list-bulleted</v-icon>
          <span class="header-title">รายการรายงานการเดินทาง</span>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหารายงาน..."
          single-line
          hide-details
          dense
          outlined
          class="search-field"
          style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="reports"
        :search="search"
        :items-per-page="10"
        class="modern-table"
        loading-text="กำลังโหลดข้อมูล..."
        no-data-text="ไม่พบข้อมูลรายงานการเดินทาง"
        no-results-text="ไม่พบผลลัพธ์ที่ค้นหา"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table-row">
            <td class="text-center">
              <v-avatar
                size="32"
                color="#2563eb"
                class="white--text font-weight-bold"
              >
                {{ index + 1 }}
              </v-avatar>
            </td>

            

             <td class="text-center">       
                <v-icon left small>mdi-account</v-icon>
                {{ item.fullname }}
             
            </td>

             <td class="text-center">            
            
                       <v-chip
                small
                color="#dbeafe"
                text-color="#2563eb"
                class="year-chip"
              >
                <v-icon left small>mdi-book-account</v-icon>
                {{ item.branch_sub_name_th }}
              </v-chip>

             
            </td>


            <td class="text-center">
              <v-chip
                small
                color="#dbeafe"
                text-color="#2563eb"
                class="year-chip"
              >
                <v-icon left small>mdi-calendar</v-icon>
                {{ formatDate(item.start_date) }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                small
                :color="getActivityTypeColor(item.activity_type)"
                dark
                class="type-chip"
              >
                <v-icon left small>{{
                  getActivityTypeIcon(item.activity_type)
                }}</v-icon>
                {{ getActivityTypeLabel(item.activity_type) }}
              </v-chip>
            </td>
            <td>
              <div class="course-cell">
                <v-icon small color="#f97316" class="mr-2"
                  >mdi-book-open-variant</v-icon
                >
                <span class="course-text">{{ item.activity_topic }}</span>
              </div>
            </td>
            <td>
              <div class="location-cell">
                <v-icon small color="#0ea5e9" class="mr-1"
                  >mdi-map-marker</v-icon
                >
                {{ item.destination }}
              </div>
            </td>
            <td class="text-center">
              <v-chip
                small
                color="#f3f4f6"
                text-color="#374151"
                class="days-chip"
              >
                {{ item.total_days }} วัน
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                small
                :color="getStatusColor(item.status)"
                text-color="white"
                class="status-chip"
              >
                {{ getStatusLabel(item.status) }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn pdf-btn mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="viewPDF(item.id)"
                  >
                    <v-icon small>mdi-file-pdf-box</v-icon>
                  </v-btn>
                </template>
                <span>ดู PDF</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn view-btn mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="viewReport(item)"
                  >
                    <v-icon small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>ดู</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn edit-btn mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="editReport(item)"
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไข</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn delete-btn"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="confirmDelete(item)"
                  >
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบ</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Add/Edit Dialog -->
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="900px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header add-header">
          <v-icon class="mr-3" color="white" size="28">
            {{ isEdit ? "mdi-pencil-outline" : "mdi-plus-circle-outline" }}
          </v-icon>
          <span>{{
            isEdit ? "แก้ไขรายงานการเดินทาง" : "เพิ่มรายงานการเดินทาง"
          }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-form ref="formRef" lazy-validation>
            <!-- Section 1: ข้อมูลพื้นฐาน -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#2563eb" class="mr-2"
                  >mdi-information-outline</v-icon
                >
                ข้อมูลพื้นฐาน
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.order_number"
                    label="เลขที่คำสั่ง"
                    placeholder="เช่น 001/2567"
                    :rules="[v => !!v || 'กรุณาระบุเลขที่คำสั่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-clipboard-text"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menuOrderDate"
                    v-model="menuOrderDate"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.order_date"
                        label="วันที่คำสั่ง"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                        :rules="[v => !!v || 'กรุณาเลือกวันที่']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.order_date"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#2563eb"
                      @input="menuOrderDate = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="form.activity_type"
                    :items="activityTypeOptions"
                    item-text="text"
                    item-value="value"
                    label="ประเภทกิจกรรม"
                    :rules="[v => !!v || 'กรุณาเลือกประเภท']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-tag-outline"
                    class="modern-input"
                  >
                    <template v-slot:item="{ item }">
                      <v-icon
                        class="mr-2"
                        :color="getActivityTypeColor(item.value)"
                        small
                      >
                        {{ getActivityTypeIcon(item.value) }}
                      </v-icon>
                      {{ item.text }}
                    </template>
                  </v-select>
                </v-col>
                <v-col v-if="form.activity_type === 'other'" cols="12">
                  <v-text-field
                    v-model="form.activity_type_other"
                    label="ระบุประเภทอื่น ๆ"
                    outlined
                    dense
                    prepend-inner-icon="mdi-text-box-outline"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section 2: เรื่องและสถานที่ -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#f97316" class="mr-2"
                  >mdi-map-search-outline</v-icon
                >
                เรื่องและสถานที่
              </div>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="form.activity_topic"
                    label="เรื่องที่ไปราชการ"
                    placeholder="ระบุเรื่องการเดินทางราชการ"
                    :rules="[v => !!v || 'กรุณาระบุเรื่อง']"
                    outlined
                    rows="2"
                    auto-grow
                    prepend-inner-icon="mdi-text-box-outline"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.destination"
                    label="สถานที่ไป"
                    placeholder="เช่น กรุงเทพฯ"
                    :rules="[v => !!v || 'กรุณาระบุสถานที่']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.organizing_unit"
                    label="หน่วยงานที่จัด"
                    placeholder="เช่น สอศ. ม.อ."
                    outlined
                    dense
                    prepend-inner-icon="mdi-domain"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="form.destination_detail"
                    label="รายละเอียดสถานที่และที่ติดต่อ"
                    placeholder="รายละเอียดเพิ่มเติม ที่ติดต่อ ที่อยู่ โทรศัพท์"
                    outlined
                    rows="2"
                    auto-grow
                    prepend-inner-icon="mdi-information-outline"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Section 3: ระยะเวลา -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#16a34a" class="mr-2">mdi-calendar-range</v-icon>
                ระยะเวลาการเดินทาง
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menuStartDate"
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.start_date"
                        label="วันที่เริ่มต้น"
                        prepend-inner-icon="mdi-calendar-start"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่ม']"
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.start_date"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#16a34a"
                      @input="onStartDateChange"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menuEndDate"
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.end_date"
                        label="วันที่สิ้นสุด"
                        prepend-inner-icon="mdi-calendar-end"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุด']"
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.end_date"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#16a34a"
                      @input="onEndDateChange"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="form.total_days"
                    label="จำนวนวัน"
                    type="number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-multiple"
                    suffix="วัน"
                    readonly
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section 4: ผู้ร่วมเดินทาง -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#8b5cf6" class="mr-2"
                  >mdi-account-multiple-outline</v-icon
                >
                ผู้ร่วมเดินทาง
              </div>
              <v-row>
                <v-col cols="12">
                  <div class="d-flex justify-end mb-3">
                    <v-btn small color="primary" @click="addCompanion">
                      <v-icon small left>mdi-plus</v-icon>
                      เพิ่มผู้ร่วมเดินทาง
                    </v-btn>
                  </div>
                  <v-card
                    v-if="form.companions && form.companions.length > 0"
                    flat
                    outlined
                    class="companion-card"
                  >
                    <v-list>
                      <v-list-item
                        v-for="(companion, idx) in form.companions"
                        :key="idx"
                        class="companion-item"
                      >
                        <v-list-item-content>
                          <v-row>
                            <v-col cols="12" md="8">
                              <v-text-field
                                v-model="companion.name"
                                label="ชื่อ-นามสกุล"
                                dense
                                outlined
                                small
                              />
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="companion.position"
                                label="ตำแหน่ง"
                                dense
                                outlined
                                small
                              />
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon small @click="removeCompanion(idx)">
                            <v-icon small color="red">mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- Section 5: ผลสัมฤทธิ์และประโยชน์ -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#d97706" class="mr-2"
                  >mdi-lightbulb-on-outline</v-icon
                >
                ผลสัมฤทธิ์และประโยชน์
              </div>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="form.achievement_knowledge"
                    label="ผลสัมฤทธิ์/ความรู้ที่ได้รับ"
                    placeholder="บรรยายผลที่ได้รับจากการไปราชการ"
                    outlined
                    rows="3"
                    auto-grow
                    prepend-inner-icon="mdi-book-open-variant"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="form.benefits_usage"
                    label="ประโยชน์ที่สามารถนำมาใช้งาน"
                    placeholder="อธิบายวิธีนำความรู้ไปประยุกต์ใช้"
                    outlined
                    rows="3"
                    auto-grow
                    prepend-inner-icon="mdi-check-circle-outline"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Section 6: เอกสารและวุฒิบัตร -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#06b6d4" class="mr-2"
                  >mdi-file-document-multiple</v-icon
                >
                เอกสารและวุฒิบัตร
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.received_documents"
                    label="เอกสาร/วัสดุที่ได้รับ"
                    placeholder="เช่น หนังสือ USB เอกสาร"
                    outlined
                    dense
                    prepend-inner-icon="mdi-folder-open"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.received_documents_location"
                    label="เก็บไว้ที่"
                    placeholder="เช่น ห้องครู โต๊ะหมายเลข 5"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="form.certificate_count"
                    label="จำนวนวุฒิบัตร"
                    type="number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-certificate"
                    suffix="ฉบับ"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menuDisseminationDate"
                    v-model="menuDisseminationDate"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.dissemination_date"
                        label="วันที่เผยแพร่ผล"
                        prepend-inner-icon="mdi-calendar-check"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.dissemination_date"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#06b6d4"
                      @input="menuDisseminationDate = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="form.dissemination_method"
                    label="วิธีการขยายผล/เผยแพร่"
                    placeholder="ระบุวิธีการแบ่งปันความรู้"
                    outlined
                    rows="2"
                    auto-grow
                    prepend-inner-icon="mdi-share-variant"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Section 7: ไฟล์แนบ - Using the Attachment Manager Component -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#10b981" class="mr-2">mdi-file-upload</v-icon>
                ไฟล์แนบ
              </div>      
              <BusinessTripAttachmentManager
                ref="attachmentManager"
                :files="form.attachments"
                :ApiKey="ApiKey"
                @file-deleted="onFileDeleted"
              />
            </div>

            <!-- Section 8: งบประมาณ (Optional) -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#ec4899" class="mr-2">mdi-currency-jpy</v-icon>
                งบประมาณ (ตัวเลือก)
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="form.budget_project_amount"
                    label="งบประมาณจากโครงการ (บาท)"
                    type="number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-currency-usd"
                    class="modern-input"
                  ></v-text-field>
                </v-col>                
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="form.budget_institution_amount"
                    label="งบประมาณจากสถานศึกษา (บาท)"
                    type="number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-currency-usd"
                    class="modern-input"
                  ></v-text-field>
                </v-col>               
              </v-row>
            </div>

            <!-- Section 9: การอนุมัติ (แก้ไขเท่านั้น) -->
            <div v-if="isEdit" class="form-section">
              <div class="section-title">
                <v-icon color="#10b981" class="mr-2"
                  >mdi-clipboard-check-outline</v-icon
                >
                สถานะและการอนุมัติ
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="form.status"
                    :items="statusOptions"
                    item-text="text"
                    item-value="value"
                    label="สถานะ"
                    outlined
                    dense
                    prepend-inner-icon="mdi-badge-account"
                    class="modern-input"
                  ></v-select>
                </v-col>
                <v-col v-if="form.status === 'approved'" cols="12" md="6">
                  <v-text-field
                    v-model="form.approved_by"
                    label="ผู้อนุมัติ"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-check"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col v-if="form.status === 'rejected'" cols="12">
                  <v-textarea
                    v-model="form.rejection_reason"
                    label="เหตุผลในการไม่อนุมัติ"
                    outlined
                    rows="2"
                    auto-grow
                    prepend-inner-icon="mdi-information-outline"
                    class="modern-input"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="closeDialog()" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            :color="isEdit ? '#f97316' : '#2563eb'"
            dark
            @click="submitForm()"
            :loading="submitting"
            class="save-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            {{ isEdit ? "บันทึกการแก้ไข" : "บันทึกข้อมูล" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- View Dialog - ✅ FIXED VERSION -->
    <v-dialog
      v-model="viewDialog"
      max-width="900px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header view-header">
          <v-icon class="mr-3" color="white" size="28">mdi-eye-outline</v-icon>
          <span>ดูรายละเอียดรายงาน</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="viewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-container v-if="viewData" fluid>
            <!-- Basic Info -->
            <v-row class="mb-4">
              <v-col cols="12">
                <h3 class="mb-3 section-header">ข้อมูลพื้นฐาน</h3>
                <v-simple-table class="info-table">
                  <tbody>
                    <tr>
                      <td class="table-label">เลขที่คำสั่ง</td>
                      <td>{{ viewData.order_number }}</td>
                    </tr>
                    <tr>
                      <td class="table-label">วันที่คำสั่ง</td>
                      <td>{{ formatDate(viewData.order_date) }}</td>
                    </tr>
                    <tr>
                      <td class="table-label">ประเภทกิจกรรม</td>
                      <td>
                        {{ getActivityTypeLabel(viewData.activity_type) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">เรื่อง</td>
                      <td>{{ viewData.activity_topic }}</td>
                    </tr>
                    <tr>
                      <td class="table-label">สถานที่ไป</td>
                      <td>{{ viewData.destination }}</td>
                    </tr>
                    <tr>
                      <td class="table-label">หน่วยงานที่จัด</td>
                      <td>{{ viewData.organizing_unit }}</td>
                    </tr>
                    <tr>
                      <td class="table-label">ระยะเวลา</td>
                      <td>
                        {{ formatDate(viewData.start_date) }} ถึง
                        {{ formatDate(viewData.end_date) }} ({{
                          viewData.total_days
                        }}
                        วัน)
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">จำนวนวุฒิบัตร</td>
                      <td>{{ viewData.certificate_count }} ฉบับ</td>
                    </tr>
                    <tr>
                      <td class="table-label">สถานะ</td>
                      <td>
                        <v-chip
                          small
                          :color="getStatusColor(viewData.status)"
                          text-color="white"
                        >
                          {{ getStatusLabel(viewData.status) }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>

            <!-- Results -->
            <v-row class="mb-4">
              <v-col cols="12">
                <h3 class="mb-3 section-header">ผลสัมฤทธิ์และประโยชน์</h3>
                <v-card flat outlined class="info-card">
                  <v-card-text>
                    <div class="mb-3">
                      <strong>ผลสัมฤทธิ์/ความรู้:</strong>
                      <p class="mt-2" style="white-space: pre-wrap;">
                        {{ viewData.achievement_knowledge || "-" }}
                      </p>
                    </div>
                    <v-divider class="my-3"></v-divider>
                    <div>
                      <strong>ประโยชน์:</strong>
                      <p class="mt-2" style="white-space: pre-wrap;">
                        {{ viewData.benefits_usage || "-" }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Companions -->
            <v-row
              v-if="viewData.companions && viewData.companions.length > 0"
              class="mb-4"
            >
              <v-col cols="12">
                <h3 class="mb-3 section-header">ผู้ร่วมเดินทาง</h3>
                <v-card flat outlined class="info-card">
                  <v-list>
                    <v-list-item
                      v-for="(companion, idx) in viewData.companions"
                      :key="idx"
                    >
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-account</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          companion.companion_name || companion.name || "-"
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          companion.companion_position ||
                            companion.position ||
                            "-"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>

            <!-- Attachments -->
            <v-row
              v-if="viewData.attachments && viewData.attachments.length > 0"
              class="mb-4"
            >
              <v-col cols="12">
                <h3 class="mb-3 section-header">
                  <v-icon small class="mr-2">mdi-file-multiple</v-icon>
                  ไฟล์แนบ ({{ viewData.attachments.length }})
                </h3>
                <v-card flat outlined class="info-card">
                  <v-list>
                    <v-list-item
                      v-for="file in viewData.attachments"
                      :key="file.id"
                      class="file-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon :color="getFileTypeColor(file.file_type)">
                          {{ getFileTypeIcon(file.file_type) }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-500">
                          {{ file.display_name || file.file_name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="file-type-badge">
                            {{ formatFileType(file.file_type) }}
                          </span>
                          <span class="file-size ml-2">
                            {{ formatFileSize(file.file_size) }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="downloadFile(file)"
                            >
                              <v-icon small color="primary"
                                >mdi-download</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>ดาวน์โหลด</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>

            <!-- Additional Info -->
            <v-row v-if="viewData.received_documents" class="mb-4">
              <v-col cols="12">
                <h3 class="mb-3 section-header">เอกสารและวัสดุที่ได้รับ</h3>
                <v-card flat outlined class="info-card">
                  <v-card-text>
                    <div class="mb-2">
                      <strong>เอกสาร/วัสดุ:</strong>
                      <p class="mt-1">{{ viewData.received_documents }}</p>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <div>
                      <strong>เก็บไว้ที่:</strong>
                      <p class="mt-1">
                        {{ viewData.received_documents_location || "-" }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="viewDialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
          <v-btn large depressed color="primary" dark @click="editFromView()">
            <v-icon left>mdi-pencil</v-icon>
            แก้ไข
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="500px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card delete-dialog">
        <v-card-title class="dialog-header delete-header">
          <v-icon class="mr-3" color="white" size="28"
            >mdi-delete-alert-outline</v-icon
          >
          <span>ยืนยันการลบข้อมูล</span>
        </v-card-title>

        <v-card-text class="delete-content text-center">
          <div class="delete-icon-wrapper">
            <v-icon size="72" color="#dc2626">mdi-alert-circle-outline</v-icon>
          </div>
          <div class="delete-message">คุณต้องการลบรายการนี้หรือไม่?</div>

          <v-card class="delete-info-card mt-4" outlined>
            <v-card-text class="pa-4">
              <div class="delete-info-item">
                <v-icon small color="#f97316" class="mr-2"
                  >mdi-book-open-variant</v-icon
                >
                <span class="info-text">{{ deleteData.activity_topic }}</span>
              </div>
              <div class="delete-info-item mt-2">
                <v-icon small color="#2563eb" class="mr-2">mdi-calendar</v-icon>
                <span class="info-text"
                  >{{ formatDate(deleteData.start_date) }} ถึง
                  {{ formatDate(deleteData.end_date) }}</span
                >
              </div>
            </v-card-text>
          </v-card>

          <div class="delete-warning mt-4">
            <v-icon small color="#f97316" class="mr-1">mdi-alert</v-icon>
            การดำเนินการนี้ไม่สามารถย้อนกลับได้
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="deleteDialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#dc2626"
            dark
            @click="confirmDeleteAction()"
            :loading="deleting"
            class="delete-confirm-btn"
          >
            <v-icon left>mdi-delete-outline</v-icon>
            ลบข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      class="modern-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" color="white">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BusinessTripReportPDF from "../../components/user/BusinessTripReportPDF.vue";
import BusinessTripAttachmentManager from "../../components/user/BusinessTripAttachmentManager.vue";

export default {
  name: "BusinessTripReportManager",
  components: {
    BusinessTripReportPDF,
    BusinessTripAttachmentManager
  },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: true,
      submitting: false,
      deleting: false,
      search: "",
      isEdit: false,
      addEditDialog: false,
      viewDialog: false,
      deleteDialog: false,
      viewData: null,
      deleteData: {},
      reports: [],
      personnel_temporary: {},
      selectedReportId: null,

      // Menu states
      menuOrderDate: false,
      menuStartDate: false,
      menuEndDate: false,
      menuDisseminationDate: false,

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },

      // Table headers
      headers: [
        {
          text: "#",
          align: "center",
          value: "index",
          width: "60px",
          sortable: false
        },
         {
          text: "ชื่อ-นามสกุล",
          align: "center",
          value: "fullname",
        },

         {
          text: "สาขางาน",
          align: "center",
          value: "branch_sub_name_th",
        },

        {
          text: "วันเริ่ม",
          align: "center",
          value: "start_date",
          width: "110px"
        },
        {
          text: "ประเภท",
          align: "center",
          value: "activity_type",
          width: "120px"
        },
        { text: "เรื่อง/หัวข้อ", align: "left", value: "activity_topic" },
        {
          text: "สถานที่",
          align: "left",
          value: "destination",
          width: "130px"
        },
        { text: "วัน", align: "center", value: "total_days", width: "80px" },
        { text: "สถานะ", align: "center", value: "status", width: "100px" },
        {
          text: "จัดการ",
          align: "center",
          value: "actions",
          sortable: false,
          width: "150px"
        }
      ],

      // Form data
      form: {
        id: "",
        id_card: "",
        employee_name: "",
        position: "",
        department: "",
        section: "",
        order_number: "",
        order_date: "",
        activity_type: "training",
        activity_type_other: "",
        activity_topic: "",
        start_date: "",
        end_date: "",
        total_days: 0,
        destination: "",
        destination_detail: "",
        organizing_unit: "",
        budget_project_amount: 0,
        budget_project_amount_text: "",
        budget_institution_amount: 0,
        budget_institution_amount_text: "",
        achievement_knowledge: "",
        benefits_usage: "",
        received_documents: "",
        received_documents_location: "",
        dissemination_method: "",
        dissemination_date: "",
        certificate_count: 0,
        certificate_note: "",
        status: "draft",
        approved_by: "",
        approved_date: "",
        rejection_reason: "",
        companions: [],
        attachments: []
      },

      // Options
      activityTypeOptions: [
        { text: "อบรม", value: "training" },
        { text: "สัมมนา", value: "seminar" },
        { text: "ประชุม", value: "meeting" },
        { text: "ศึกษาดูงาน", value: "study_visit" },
        { text: "อื่น ๆ", value: "other" }
      ],

      statusOptions: [
        { text: "ร่าง", value: "draft" },
        { text: "เสนอ", value: "send" },
        { text: "รอพิจารณา", value: "pending" },
        { text: "อนุมัติ", value: "approved" },
        { text: "ไม่อนุมัติ", value: "rejected" }
      ],

      personnel_etcs: [],
      users:[],
    };
  },

  computed: {
    totalDays() {
      return this.reports.reduce((sum, item) => {
        return sum + (parseInt(item.total_days) || 0);
      }, 0);
    }
  },

  async mounted() {
    await this.loadUserData();
    await this.personnel_etcsQuery();
    await this.loadReports();
  },

  methods: {
    // ========== Load Data Methods ==========
    async personnel_etcsQuery() {
      this.loading = true;
      try {
        const result = await this.$http.post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          personnel_etc_college_code: this.personnel_temporary.college_code
        });
        this.personnel_etcs = result.data;
      } catch (error) {
        console.error("Personnel ETC query error:", error);
      } finally {
        this.loading = false;
      }
    },

    async loadUserData() {
      try {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("admin.php", {
        user_name: userSession.user_name,
        provice: "check",
        ApiKey: "HRvec2021"
      });
      this.users = result.data;
      console.log(result.data)
      } catch (error) {
        this.showSnackbar(
          "เกิดข้อผิดพลาดในการโหลดข้อมูล",
          "error",
          "mdi-alert"
        );
      }
    },

    async loadReports() {
      this.loading = true;
      try {
        const result = await this.$http.post(
          "gov_business_trip_report_select.php",
          {
            ApiKey: this.ApiKey,
            college_code: this.users.user_code || ""
          }
        );
        console.log('gov_business_trip_report_select :' ,result.data)

        // ✅ ตรวจสอบ response structure
        if (result.data.data) {
          this.reports = result.data.data;
        } else if (Array.isArray(result.data)) {
          this.reports = result.data;
        } else {
          this.reports = [];
        }

        console.log("Loaded reports:", this.reports);
      } catch (error) {
        console.error("Load reports error:", error);
        this.showSnackbar(
          "เกิดข้อผิดพลาดในการโหลดข้อมูล",
          "error",
          "mdi-alert"
        );
      } finally {
        this.loading = false;
      }
    },

    // ========== Dialog Methods ==========
    openAddDialog() {
      this.isEdit = false;
      this.resetForm();
      this.addEditDialog = true;
    },

    closeDialog() {
      this.addEditDialog = false;
      this.resetForm();
      if (this.$refs.attachmentManager) {
        this.$refs.attachmentManager.resetFiles();
      }
    },

    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.reset();
      }
      Object.assign(this.form, {
        id: "",
        id_card: this.personnel_temporary.id_card || "",
        employee_name: this.personnel_temporary.name || "",
        position: this.personnel_temporary.position || "",
        department: this.personnel_temporary.department || "",
        section: this.personnel_temporary.section || "",
        order_number: "",
        order_date: "",
        activity_type: "training",
        activity_type_other: "",
        activity_topic: "",
        start_date: "",
        end_date: "",
        total_days: 0,
        destination: "",
        destination_detail: "",
        organizing_unit: "",
        budget_project_amount: 0,
        budget_project_amount_text: "",
        budget_institution_amount: 0,
        budget_institution_amount_text: "",
        achievement_knowledge: "",
        benefits_usage: "",
        received_documents: "",
        received_documents_location: "",
        dissemination_method: "",
        dissemination_date: "",
        certificate_count: 0,
        certificate_note: "",
        status: "draft",
        approved_by: "",
        approved_date: "",
        rejection_reason: "",
        companions: [],
        attachments: []
      });
    },

    // ========== View/Edit Methods ==========
    async viewReport(item) {
      try {
        const result = await this.$http.post(
          "gov_business_trip_report_select.php",
          {
            ApiKey: this.ApiKey,
            id: item.id
          }
        );

        this.viewData = result.data;

        console.log("View Report Data:", this.viewData);
        console.log("Companions:", this.viewData.companions);
        console.log("Attachments:", this.viewData.attachments);

        this.viewDialog = true;
      } catch (error) {
        console.error("View report error:", error);
        this.showSnackbar("ไม่สามารถโหลดรายละเอียด", "error", "mdi-alert");
      }
    },

    editReport(item) {
      this.isEdit = true;

      // ✅ ตรวจสอบ companions format
      let companions = [];
      if (item.companions && Array.isArray(item.companions)) {
        companions = item.companions.map((c) => ({
          name: c.companion_name || "",
          position: c.companion_position || ""
        }));
      }

      // ✅ ตรวจสอบ attachments
      let attachments = [];
      if (item.attachments && Array.isArray(item.attachments)) {
        attachments = item.attachments;
      }

      console.log('attachments : ',attachments)
      // ✅ กำหนดข้อมูลฟอร์ม
      this.form = {
        id: item.id || "",
        id_card: item.id_card || "",
        employee_name: item.employee_name || "",
        position: item.position || "",
        department: item.department || "",
        section: item.section || "",
        order_number: item.order_number || "",
        order_date: item.order_date || "",
        activity_type: item.activity_type || "training",
        activity_type_other: item.activity_type_other || "",
        activity_topic: item.activity_topic || "",
        start_date: item.start_date || "",
        end_date: item.end_date || "",
        total_days: item.total_days || 0,
        destination: item.destination || "",
        destination_detail: item.destination_detail || "",
        organizing_unit: item.organizing_unit || "",
        budget_project_amount: item.budget_project_amount || 0,
        budget_project_amount_text: item.budget_project_amount_text || "",
        budget_institution_amount:
          item.budget_institution_amount || 0,
        budget_institution_amount_text:
          item.budget_institution_amount_text || "",
        achievement_knowledge: item.achievement_knowledge || "",
        benefits_usage: item.benefits_usage || "",
        received_documents: item.received_documents || "",
        received_documents_location:
          item.received_documents_location || "",
        dissemination_method: item.dissemination_method || "",
        dissemination_date: item.dissemination_date || "",
        certificate_count: item.certificate_count || 0,
        certificate_note: item.certificate_note || "",
        status: item.status || "draft",
        approved_by: item.approved_by || "",
        approved_date: item.approved_date || "",
        rejection_reason: item.rejection_reason || "",
        companions: companions,
        attachments: attachments
      };

      this.addEditDialog = true;

      console.log("Edit Report - Companions:", this.form.companions);
      console.log("Edit Report - Attachments:", this.form.attachments);
    },

    editFromView() {
      this.viewDialog = false;
      this.editReport(this.viewData);
    },

    confirmDelete(item) {
      this.deleteData = item;
      this.deleteDialog = true;
    },

    async confirmDeleteAction() {
      this.deleting = true;
      try {
        const result = await this.$http.post(
          "gov_business_trip_report_delete.php",
          {
            ApiKey: this.ApiKey,
            id: this.deleteData.id
          }
        );

        if (result.data.status) {
          Swal.fire({
            icon: "success",
            title: "ลบสำเร็จ",
            text: "ลบรายงานการเดินทางเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500
          });
          this.deleteDialog = false;
          this.loadReports();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถลบข้อมูลได้",
          showConfirmButton: true
        });
      } finally {
        this.deleting = false;
      }
    },

    // ========== Form Submission ==========
    async submitForm() {
      if (!this.$refs.formRef.validate()) return;

      this.submitting = true;
      const isAdd = !this.isEdit;
      const endpoint = isAdd
        ? "gov_business_trip_report_insert.php"
        : "gov_business_trip_report_update.php";

      const data = {
        ApiKey: this.ApiKey,
        ...this.form,
        updated_by: this.users.user_code || "system"
      };

      try {
        const response = await this.$http.post(endpoint, data);

        if (response.data.status) {
          const reportId = response.data.id || this.form.id;

          // Upload files if any
          const newFiles = this.$refs.attachmentManager.getNewFiles();
          if (newFiles.length > 0) {
            const uploadPromises = newFiles.map((file) => {
              const formData = new FormData();
              formData.append("file", file.file);
              formData.append("ApiKey", this.ApiKey);
              formData.append("file_type", file.file_type);
              formData.append("report_id", reportId);

              return this.$http.post(
                "gov_business_trip_report_upload.php",
                formData
              );
            });

            try {
              await Promise.all(uploadPromises);
              this.showSuccessMessage(isAdd);
            } catch (uploadError) {
              console.error("Upload error:", uploadError);
              this.showSnackbar(
                "ไฟล์บางไฟล์อัปโหลดไม่สำเร็จ แต่บันทึกข้อมูลสำเร็จ",
                "warning",
                "mdi-alert"
              );
              this.showSuccessMessage(isAdd);
            }
          } else {
            this.showSuccessMessage(isAdd);
          }
        } else {
          throw new Error(response.data.message || "ไม่ทราบข้อผิดพลาด");
        }
      } catch (error) {
        console.error("Submit error:", error);

        let errorMessage = "เกิดข้อผิดพลาดในการบันทึกข้อมูล";

        if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: errorMessage,
          showConfirmButton: true
        });
      } finally {
        this.submitting = false;
      }
    },

    showSuccessMessage(isAdd) {
      Swal.fire({
        icon: "success",
        title: isAdd ? "บันทึกสำเร็จ" : "แก้ไขสำเร็จ",
        text: isAdd
          ? "เพิ่มรายงานการเดินทางเรียบร้อยแล้ว"
          : "อัปเดตรายงานการเดินทางเรียบร้อยแล้ว",
        showConfirmButton: false,
        timer: 1500
      });
      this.closeDialog();
      this.loadReports();
    },

    // ========== File Management ==========
    onFileDeleted(file) {
      // Remove from attachments
      const index = this.form.attachments.findIndex((f) => f.id === file.id);
      if (index > -1) {
        this.form.attachments.splice(index, 1);
      }
      this.showSnackbar("ลบไฟล์สำเร็จ", "success", "mdi-check-circle");
    },

    downloadFile(file) {
      const link = document.createElement("a");
      link.href = file.file_path;
      link.download = file.file_name;
      link.click();
    },

    formatFileSize(bytes) {
      if (!bytes) return "-";
      const kb = bytes / 1024;
      if (kb < 1024) {
        return kb.toFixed(2) + " KB";
      }
      const mb = kb / 1024;
      return mb.toFixed(2) + " MB";
    },

    formatFileType(type) {
      const types = {
        certificate: "วุฒิบัตร",
        document: "เอกสาร",
        material_photo: "รูปภาพ",
        other: "อื่น ๆ"
      };
      return types[type] || type;
    },

    getFileTypeColor(type) {
      const colors = {
        certificate: "#dc2626",
        document: "#2563eb",
        material_photo: "#10b981",
        other: "#6b7280"
      };
      return colors[type] || "#6b7280";
    },

    getFileTypeIcon(type) {
      const icons = {
        certificate: "mdi-file-certificate",
        document: "mdi-file-document",
        material_photo: "mdi-file-image",
        other: "mdi-file"
      };
      return icons[type] || "mdi-file";
    },

    // ========== Companion Methods ==========
    addCompanion() {
      if (!this.form.companions) {
        this.form.companions = [];
      }

      if (this.form.companions.length >= 20) {
        this.showSnackbar(
          "สามารถเพิ่มผู้ร่วมได้สูงสุด 20 คน",
          "warning",
          "mdi-alert"
        );
        return;
      }

      this.form.companions.push({
        name: "",
        position: ""
      });

      console.log("Added companion, total:", this.form.companions.length);
    },

    removeCompanion(index) {
      if (index >= 0 && index < this.form.companions.length) {
        const removed = this.form.companions[index];
        this.form.companions.splice(index, 1);

        this.showSnackbar(
          `ลบ ${removed.name || "ผู้ร่วมไป"} สำเร็จ`,
          "info",
          "mdi-information"
        );

        console.log("Removed companion, total:", this.form.companions.length);
      }
    },

    // ========== Helper Methods ==========
    countByStatus(status) {
      return this.reports.filter((item) => item.status === status).length;
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      return new Date(dateString).toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    },

    getActivityTypeLabel(type) {
      const types = {
        training: "อบรม",
        seminar: "สัมมนา",
        meeting: "ประชุม",
        study_visit: "ศึกษาดูงาน",
        other: "อื่น ๆ"
      };
      return types[type] || type;
    },

    getActivityTypeColor(type) {
      const colors = {
        training: "#0ea5e9",
        seminar: "#10b981",
        meeting: "#f97316",
        study_visit: "#8b5cf6",
        other: "#6b7280"
      };
      return colors[type] || "#6b7280";
    },

    getActivityTypeIcon(type) {
      const icons = {
        training: "mdi-school",
        seminar: "mdi-presentation",
        meeting: "mdi-account-multiple",
        study_visit: "mdi-map-search-outline",
        other: "mdi-information"
      };
      return icons[type] || "mdi-information";
    },

    getStatusLabel(status) {
      const statuses = {
        draft: "ร่าง",
        send: "เสนอ",
        pending: "รอพิจารณา",
        approved: "อนุมัติ",
        rejected: "ไม่อนุมัติ"
      };
      return statuses[status] || status;
    },

    getStatusColor(status) {
      const colors = {
        draft: "#9ca3af",
        send:"#29EF1EFF",
        pending: "#f59e0b",
        approved: "#10b981",
        rejected: "#ef4444"
      };
      return colors[status] || "#9ca3af";
    },

    // ========== Date Methods ==========
    onStartDateChange() {
      this.menuStartDate = false;
      this.calculateDays();
    },

    onEndDateChange() {
      this.menuEndDate = false;
      this.calculateDays();
    },

    calculateDays() {
      if (this.form.start_date && this.form.end_date) {
        const start = new Date(this.form.start_date);
        const end = new Date(this.form.end_date);
        const days =
          Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
        this.form.total_days = days > 0 ? days : 0;
      }
    },

    // ========== PDF Viewer ==========
    viewPDF(reportId) {
      this.selectedReportId = reportId;
      this.$nextTick(() => {
        if (this.$refs.pdfComponent) {
          this.$refs.pdfComponent.openPDFViewer();
        }
      });
    },

    // ========== Snackbar ==========
    showSnackbar(text, color, icon) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 4000
      };
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap");

.business-trip-container {
  font-family: "Prompt", sans-serif;
  padding: 24px;
  background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
  min-height: 100vh;
}

/* ========== Hero Header ========== */
.hero-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #1e40af 100%);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 40px rgba(37, 99, 235, 0.3);
}

.hero-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.06'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.hero-content {
  display: flex;
  align-items: center;
  padding: 32px;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
  gap: 16px;
}

.hero-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.hero-text {
  color: white;
}

.hero-title {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.hero-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.add-btn {
  background: white !important;
  color: #2563eb !important;
  font-weight: 500;
  border-radius: 12px;
  padding: 0 28px !important;
  text-transform: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* ========== Statistics ========== */
.stats-row {
  margin-top: -16px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card-1 .stat-icon {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.stat-card-2 .stat-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-card-3 .stat-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.stat-card-4 .stat-icon {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1;
}

.stat-label {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}

/* ========== Main Table ========== */
.main-table-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.table-header {
  padding: 20px 24px;
  background: #fafafa;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.search-field {
  background: white;
}

.search-field >>> .v-input__slot {
  border-radius: 12px !important;
}

.modern-table {
  font-family: "Prompt", sans-serif;
}

.modern-table >>> thead th {
  background: #dbeafe !important;
  color: #1e40af !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #bfdbfe !important;
  padding: 14px 8px !important;
}

.table-row {
  transition: all 0.2s ease;
}

.table-row:hover {
  background: #f0f9ff !important;
}

.table-row td {
  padding: 14px 8px !important;
  border-bottom: 1px solid #f3f4f6 !important;
  font-size: 13px;
  color: #374151;
}

.course-cell {
  display: flex;
  align-items: flex-start;
  max-width: 250px;
}

.course-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.location-cell {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.type-chip,
.year-chip,
.days-chip,
.status-chip {
  font-size: 14px !important;
  font-weight: 500;
}

/* ========== Action Buttons ========== */
.action-btn {
  width: 32px !important;
  height: 32px !important;
  transition: all 0.2s ease;
}

.pdf-btn {
  background: #fef3c7 !important;
  color: #d97706 !important;
}

.pdf-btn:hover {
  background: #fde68a !important;
  transform: scale(1.1);
}

.view-btn {
  background: #eff6ff !important;
  color: #2563eb !important;
}

.view-btn:hover {
  background: #dbeafe !important;
  transform: scale(1.1);
}

.edit-btn {
  background: #fff7ed !important;
  color: #f97316 !important;
}

.edit-btn:hover {
  background: #ffedd5 !important;
  transform: scale(1.1);
}

.delete-btn {
  background: #fef2f2 !important;
  color: #dc2626 !important;
}

.delete-btn:hover {
  background: #fecaca !important;
  transform: scale(1.1);
}

/* ========== Dialog ========== */
.modern-dialog {
  border-radius: 20px !important;
}

.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  padding: 20px 24px;
  font-size: 18px;
  font-weight: 600;
}

.add-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
}

.view-header {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
}

.delete-header {
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  color: white;
}

.dialog-content {
  padding: 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}

.form-section {
  background: #fafafa;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #f3f4f6;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-header {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
}

.modern-input >>> .v-input__slot {
  background: white !important;
  border-radius: 10px !important;
}

.companion-card {
  background: white !important;
  border: 1px solid #e5e7eb !important;
}

.companion-item {
  border-bottom: 1px solid #f3f4f6 !important;
}

.companion-item:last-child {
  border-bottom: none !important;
}

.file-list-item {
  border-bottom: 1px solid #f3f4f6 !important;
  transition: all 0.2s ease;
}

.file-list-item:hover {
  background: #f9fafb !important;
}

.file-list-item:last-child {
  border-bottom: none !important;
}

/* ========== Info Table & Cards ========== */
.info-table {
  background: transparent !important;
}

.info-table >>> tbody tr {
  border-bottom: 1px solid #f3f4f6;
}

.info-table >>> tbody tr:last-child {
  border-bottom: none;
}

.table-label {
  font-weight: 600;
  width: 200px;
  color: #374151;
  background: #f9fafb;
}

.info-table >>> tbody td {
  padding: 12px 16px !important;
}

.info-card {
  background: #fafafa !important;
  border: 1px solid #e5e7eb !important;
}

.file-type-badge {
  display: inline-block;
  background: #eff6ff;
  color: #1e40af;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
}

.file-size {
  color: #9ca3af;
  font-size: 12px;
}

.dialog-actions {
  padding: 16px 24px;
  background: #fafafa;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
  text-transform: none;
}

.save-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
  padding: 0 24px !important;
}

/* ========== Delete Dialog ========== */
.delete-content {
  padding: 32px 24px !important;
}

.delete-icon-wrapper {
  margin-bottom: 16px;
}

.delete-message {
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
}

.delete-info-card {
  background: #fafafa !important;
  border-radius: 12px !important;
  border-color: #e5e7eb !important;
  text-align: left;
}

.delete-info-item {
  display: flex;
  align-items: flex-start;
}

.delete-warning {
  font-size: 13px;
  color: #f97316;
}

.delete-confirm-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
}

/* ========== Snackbar ========== */
.modern-snackbar {
  font-family: "Prompt", sans-serif;
}

/* ========== Animations ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.stat-card:nth-child(1) {
  animation-delay: 0.1s;
}

.stat-card:nth-child(2) {
  animation-delay: 0.2s;
}

.stat-card:nth-child(3) {
  animation-delay: 0.3s;
}

.stat-card:nth-child(4) {
  animation-delay: 0.4s;
}

/* ========== Responsive ========== */
@media (max-width: 960px) {
  .hero-content {
    padding: 24px;
  }

  .hero-icon-wrapper {
    width: 64px;
    height: 64px;
  }

  .hero-title {
    font-size: 20px;
  }

  .add-btn {
    width: 100%;
  }

  .course-cell {
    max-width: 150px;
  }
}

@media (max-width: 600px) {
  .business-trip-container {
    padding: 16px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-number {
    font-size: 24px;
  }

  .table-label {
    width: 120px;
    font-size: 12px;
  }

  .dialog-content {
    max-height: 80vh;
  }
}

/* ========== Scrollbar Styling ========== */
.dialog-content::-webkit-scrollbar {
  width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>